module.exports = __webpack_public_path__ + "media/country_flags/pf-feb14bd2.png";